import { useEffect, useState } from "react";

import env, { normalPriceCount } from "../../env";

import ManageUser from "./ManageUser";

import { useNavigate } from "react-router-dom";

function OrderHeader(props) {
  const navigate = useNavigate();
  const token = props.token;

  const [showDrop, setShowDrop] = useState(0);
  const [showProduct, setShowProduct] = useState(0);
  const [showUsers, setShowUsers] = useState(0);

  const [customers, setCustomers] = useState();
  const [ProductList, setProductList] = useState("");
  const [LivePrice, setLivePrice] = useState("");

  const [goldLastUpdate, setGoldLastUpdate] = useState(null);
  const [Refresh, setRefresh] = useState(0);

  // وضعیت سپیدار
  const [sepidarStatus, setSepidarStatus] = useState(null);
  const [sepidarLastUpdate, setSepidarLastUpdate] = useState(null);
  const [sepidarLoading, setSepidarLoading] = useState(false);

  const ProductInfo = props.ProductInfo;
  const setProductInfo = props.setProductInfo;

  // =========================
  // قیمت طلا
  // =========================
  useEffect(() => {
    setLivePrice("");

    const postOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
    };

    fetch(env.siteApi + "/panel/faktor/price", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setLivePrice(result?.data ?? "");
          setGoldLastUpdate(result?.lastUpdate ?? null);
        },
        (error) => {
          console.log(error);
          setGoldLastUpdate(null);
        },
      );
  }, [Refresh, token]);

  // =========================
  // وضعیت سپیدار
  // =========================
  const checkSepidarStatus = () => {
    setSepidarLoading(true);

    const postOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
    };

    fetch(env.siteApi + "/setting/check-server", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setSepidarStatus(result?.data ?? false);
          setSepidarLastUpdate(result?.lastUpdate ?? null);
        },
        (error) => {
          console.log(error);
          setSepidarStatus(false);
          setSepidarLastUpdate(null);
        },
      )
      .catch((error) => {
        console.log(error);
        setSepidarStatus(false);
        setSepidarLastUpdate(null);
      })
      .finally(() => {
        setSepidarLoading(false);
      });
  };

  useEffect(() => {
    checkSepidarStatus();

    const interval = setInterval(
      () => {
        checkSepidarStatus();
      },
      10 * 60 * 1000,
    );

    return () => clearInterval(interval);
  }, [token]);

  // =========================
  // پیدا کردن مشتری
  // =========================
  const findCustomer = (search) => {
    if (search.length < 3) {
      return;
    }

    const postOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({ search: search }),
    };

    fetch(env.siteApi + "/panel/faktor/customer-find", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.customers) {
            if (result.error) {
              props.setError({
                message: result.error,
                color: "brown",
              });
            } else {
              setCustomers(result.customers);
            }
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  // =========================
  // پیدا کردن محصول
  // =========================
  const findProduct = (search) => {
    if (search.length < 1) {
      return;
    }

    const postOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({ search: search }),
    };

    fetch(env.siteApi + "/panel/faktor/list-product-sale", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setProductList(result);
        },
        (error) => {
          console.log(error);
        },
      );
  };

  let typingTimer;
  const doneTypingInterval = 1000;

  const handleCustomerSearchChange = (e) => {
    clearTimeout(typingTimer);

    const search = e.target.value;

    typingTimer = setTimeout(() => {
      findCustomer(search);
    }, doneTypingInterval);
  };

  const handleProductSearchChange = (e) => {
    clearTimeout(typingTimer);

    const search = e.target.value;

    typingTimer = setTimeout(() => {
      findProduct(search);
    }, doneTypingInterval);
  };

  const gotToOpenOrders = () => {
    navigate("/orders/open");
  };

  const logOff = () => {
    const Cookies = require("universal-cookie");
    const cookies = new Cookies();

    cookies.remove(env.cookieName, { path: "/" });

    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  return (
    <div className="nav-bar">
      <div
        className="icon-wrapper"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",

          width: "100%",
        }}
      >
        {/* =========================
            قیمت طلا و وضعیت سپیدار
            روبه‌روی هم
        ========================= */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "15px",
            direction: "rtl",
            padding: "0px 6px",

            width: "100%",
          }}
        >
          {/* وضعیت سپیدار */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              fontSize: "14px",
              whiteSpace: "nowrap",
              direction: "rtl",
              color: "black",
              marginRight: "1rem",
            }}
          >
            <span> ته حساب:</span>

            <span
              style={{
                color:
                  sepidarStatus === true
                    ? "green"
                    : sepidarStatus === false
                      ? "red"
                      : "#777",
                fontWeight: 600,
              }}
            >
              {sepidarLoading
                ? "در حال بررسی..."
                : sepidarStatus === true
                  ? "متصل"
                  : sepidarStatus === false
                    ? "قطع"
                    : "نامشخص"}
            </span>

            <i
              onClick={checkSepidarStatus}
              className="fa fa-refresh"
              aria-hidden="true"
              style={{
                cursor: "pointer",
                fontSize: "11px",
              }}
              title="بررسی وضعیت ته حساب"
            ></i>

            {/*
            {sepidarLastUpdate && (
              <span
                style={{
                  fontSize: "10px",
                  color: "#777",
                }}
              >
                آخرین بروزرسانی:{" "}
                {new Date(sepidarLastUpdate).toLocaleString("fa-IR")}
              </span>
            )}
            */}
          </div>

          {/* قیمت طلا */}
          <div
            onClick={() => setRefresh((prev) => prev + 1)}
            className="LivePrice"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "14px",
              whiteSpace: "nowrap",
              direction: "rtl",
              border: "none",
            }}
          >
            <span>
              {new Date(goldLastUpdate).toLocaleTimeString("fa-IR", {
                hour: "2-digit",
                minute: "2-digit",
              })}{" "}
            </span>
            <span>
              {LivePrice !== ""
                ? normalPriceCount(LivePrice)
                : "در حال دریافت..."}
            </span>

            {/*
            {goldLastUpdate && (
              <span
                style={{
                  fontSize: "10px",
                  color: "#777",
                }}
              >
                آخرین بروزرسانی:{" "}
                {new Date(goldLastUpdate).toLocaleString("fa-IR")}
              </span>
            )}
            */}
          </div>
        </div>
        {/* =========================
            اطلاعات کاربر
        ========================= */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row-reverse",
            gap: "10px",
            width: "100%",
            height: "40px",
          }}
        >
          <p style={{ margin: 0 }}>{props.token.username}</p>

          <i className="fa fa-sign-out" aria-hidden="true" onClick={logOff}></i>
        </div>
      </div>

      {/* =========================
          لوگو
      ========================= */}
      <div className="logo-wrapper">
        <img src="\img\zar-logo.PNG" alt="Logo" />
      </div>

      {/* =========================
          مشتری
      ========================= */}
      {props.user ? (
        <div className="f-customer">
          <div className="user-item">
            <b>
              {props.user.username}

              {props.user.agent ? (
                <></>
              ) : (
                <i className="fa-solid fa-check-circle" aria-hidden="true"></i>
              )}

              <small>
                ({props.user.phone ? props.user.phone : props.user.mobile})
              </small>
            </b>

            <small>{props.user.Address ? props.user.Address : "-"}</small>
          </div>

          <i
            className="fa-solid fa-remove"
            style={{
              margin: "0",
              color: "#000",
            }}
            onClick={() => props.setUser("")}
          ></i>
        </div>
      ) : (
        <div className="f-customer">
          <input
            type="search"
            name=""
            id="f-search"
            placeholder="مشتری"
            onChange={(e) => handleCustomerSearchChange(e)}
            onFocus={() => setShowDrop(1)}
            onBlur={() => setTimeout(() => setShowDrop(0), 200)}
          />

          <i
            className="fa-solid fa-plus"
            style={{
              margin: "0",
              color: "#000",
            }}
            onClick={() => setShowUsers(1)}
          ></i>
        </div>
      )}

      {/* =========================
          محصول
      ========================= */}
      {props.user ? (
        <></>
      ) : ProductInfo ? (
        <div className="f-customer">
          <div className="user-item">
            <b>
              {ProductInfo.title}
              <small>({ProductInfo.sku})</small>
            </b>
          </div>

          <i
            className="fa-solid fa-remove"
            style={{
              margin: "0",
              color: "#000",
            }}
            onClick={() => props.setProductInfo("")}
          ></i>
        </div>
      ) : (
        <div className="f-customer">
          <input
            type="search"
            name=""
            id="p-search"
            placeholder="جستجوی اتیکت"
            onChange={(e) => handleProductSearchChange(e)}
            onFocus={() => setShowProduct(1)}
            onBlur={() => setTimeout(() => setShowProduct(0), 200)}
          />

          <i
            className="fa-solid fa-search"
            style={{
              margin: "0",
              color: "#000",
            }}
          ></i>
        </div>
      )}

      {/* =========================
          لیست مشتری‌ها
      ========================= */}
      {showDrop ? (
        <div className="f-customer-dropdpwn">
          {customers &&
            customers.map((customer, i) => (
              <div
                className="menu-item"
                key={i}
                onClick={() => {
                  props.setUser(customer);
                  props.setProductInfo("");
                }}
              >
                <p className="bu-name">
                  {customer.username}

                  {customer.agent ? (
                    <></>
                  ) : (
                    <i
                      className="fa-solid fa-check-circle"
                      aria-hidden="true"
                    ></i>
                  )}
                </p>

                <div className="info-holder col">
                  <span>
                    <i
                      className="fa-solid fa-phone no-font id-icon"
                      aria-hidden="true"
                    ></i>

                    {customer.phone ? customer.phone : "........"}
                  </span>
                </div>

                <p className="bu-address">
                  {customer.Address ? customer.Address : "-"}
                </p>
              </div>
            ))}
        </div>
      ) : (
        <></>
      )}

      {/* =========================
          لیست محصولات
      ========================= */}
      {showProduct ? (
        <div className="f-customer-dropdpwn">
          {ProductList &&
            ProductList.data &&
            ProductList.data.map((product, i) => (
              <div
                className="menu-item"
                key={i}
                onClick={() => setProductInfo(product)}
              >
                <p className="bu-name">
                  {product.feature && (
                    <i
                      className="fa fa-check-circle"
                      style={{
                        fontSize: "20px",
                      }}
                      aria-hidden="true"
                    ></i>
                  )}

                  {product.title}
                </p>

                <div className="info-holder col">
                  <span>
                    <i
                      className="fa-solid fa-barcode no-font id-icon"
                      aria-hidden="true"
                    ></i>

                    {product.sku}
                  </span>

                  <span className="icon-span">
                    <img src="/img/weight-icon.png" alt="weight" />

                    {product.weight}
                  </span>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <></>
      )}

      <ManageUser show={showUsers} close={() => setShowUsers(0)} />
    </div>
  );
}

export default OrderHeader;
